'use client';

import { observer } from 'mobx-react-lite';
import { Flex, Stack, Text, SegmentedControls } from '@instamenu/ui-system-next';
import { useCheckoutContext } from '@instamenu/context-checkout';
import { palette } from '@instamenu/ui-vanilla-extract';
import { roundUpTo } from '@instamenu/formatters';
import { useMediaQuery } from 'react-responsive';
import { breakpoints } from '@instamenu/ui-vanilla-extract';
import { OrderScheduleModal } from './order-schedule-modal';
import { useState } from 'react';
import { Fulfillment } from '@instamenu/data-access';

export const OrderSchedule = observer(() => {
  const checkout = useCheckoutContext();
  const [open, setOpen] = useState(false);
  const isDesktop = useMediaQuery({ query: breakpoints.desktop });

  if (!checkout?.order.maySchedule) return null;
  const { order, restaurant } = checkout;

  const minutes =
    checkout.mode === Fulfillment.Delivery
      ? checkout.deliveryEstimateMinutes
      : checkout.restaurant.waitTime;

  const standardDescription = typeof minutes === 'number' ? `${roundUpTo(minutes, 5)} min` : '-';

  const options = [];
  if (checkout.isAcceptingInstantOrders)
    options.push({ label: 'Standard', description: standardDescription, value: 'standard' });
  if (order.maySchedule)
    options.push({
      label: 'Schedule for later',
      description: order.scheduledAt
        ? order.scheduledAt.toFormat('LLLL d, h:mm a')
        : 'Choose a time',
      value: 'scheduled',
    });

  const onChange = (value: string) => {
    if (value === 'scheduled') {
      setOpen(true);
    } else {
      order.scheduledAt = null;
    }
  };

  return (
    <>
      <Stack>
        {(order.maySchedule && !checkout.isAcceptingInstantOrders) || order.mustSchedule ? (
          <Stack css={{ gap: 8, alignItems: 'flex-start' }}>
            <Text>{restaurant.name} is currently only accepting scheduled orders.</Text>
            <SegmentedControls
              options={options}
              value={order.scheduledAt ? 'scheduled' : ''}
              onChange={onChange}
              ariaLabel="Order time"
            />
          </Stack>
        ) : (
          <div>
            <Text variant="caption1" css={{ color: palette.gray600, paddingBottom: 8 }}>
              When do you want your order?
            </Text>
            <Flex style={{ gap: 16 }}>
              <SegmentedControls
                options={options}
                value={
                  order.scheduledAt
                    ? 'scheduled'
                    : checkout.isAcceptingInstantOrders
                      ? 'standard'
                      : ''
                }
                onChange={onChange}
                ariaLabel="When do you want your order?"
              />
            </Flex>
          </div>
        )}
      </Stack>
      <OrderScheduleModal order={order} setOpen={setOpen} open={open} isDesktop={isDesktop} />
    </>
  );
});
